import React, { useEffect, useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { usePatchForm } from '../../providers/PatchFormProvider';
import { useAuth } from 'oidc-react';
import Project from '../../common/Utils/project';
import { useTenantSelection } from '../../providers/TenantSelectionProvider';
import api from '../../components/services/apiService';

const InstallDropdown = () => {
  const { patchFormData, setPatchFormData } = usePatchForm();
  const [isExpanded, setIsExpanded] = useState(false);
  const [apply, setApply] = useState(false);
  const [softwareList, setSoftwareList] = useState([]);
  const auth = useAuth();
  const { selectedTenantId } = useTenantSelection();

  useEffect(() => {
    const getSoftwareDeploymentList = async () => {
      try {
        if (auth?.userData) {
          const token = auth.userData.access_token;
          const tenantId = selectedTenantId;
          const { data } = await api.get(`${Project.api}softwaredeploymentservice/SoftwareDeployment/${tenantId}/software-deployment-list`);
          if (data?.isSuccess && Array.isArray(data.data)) {
            setSoftwareList(data.data);
          }
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };
    getSoftwareDeploymentList();
  }, [auth]);

  useEffect(() => {
    if (patchFormData?.RemediationPlanActionList?.some((a: any) => a.ActionType === 'SoftwareInstall')) {
      setApply(true);
    }
  }, [patchFormData]);

  const toggleSoftware = (item: any) => {
    setPatchFormData((prev: any) => {
      // Remove any existing SoftwareInstall actions
      const filteredList = (prev.RemediationPlanActionList ?? []).filter((a: any) => a.ActionType !== 'SoftwareInstall');

      // Add the newly selected software
      const newInstall = {
        ActionType: 'SoftwareInstall',
        PackageIdentifier: item.applicationName,
        VersionToBeInstalled: '',
        BlobURL: item.filePath,
      };

      return {
        ...prev,
        RemediationPlanActionList: [...filteredList, newInstall],
      };
    });
  };

  return (
    <div className={`bg-[#1e1e1e] text-white p-4 rounded-md border ${apply ? 'border-green-500' : 'border-gray-600'}`}>
      {isExpanded && <div className="mb-2 text-gray-300">Install Software</div>}

      <div
        className="flex justify-between items-center cursor-pointer p-3 bg-[#2a2a2a] rounded-md"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span className="text-white">Install Software</span>
        {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
      </div>

      {isExpanded && (
        <div className="mt-2 bg-[#2a2a2a] border border-gray-600 rounded-md">
          {softwareList.length === 0 ? (
            <div className="p-3 text-gray-400 text-center">No software available</div>
          ) : (
            softwareList.map((item) => {
              const isSelected = patchFormData.RemediationPlanActionList?.some(
                (a) => a.ActionType === 'SoftwareInstall' && a.PackageIdentifier === item.applicationName,
              );
              return (
                <div
                  key={item.id}
                  className={`flex items-center px-4 py-3 cursor-pointer border-b border-gray-700 last:border-0
        ${isSelected ? 'bg-gray-700' : 'hover:bg-gray-800'}`}
                  onClick={() => toggleSoftware(item)}
                >
                  {/* Custom green checkbox */}
                  <div
                    className={`w-5 h-5 mr-3 flex-shrink-0 rounded-sm border border-gray-400 
          ${isSelected ? 'bg-green-500 border-green-500' : 'bg-transparent'}`}
                  ></div>

                  {/* Texts together */}
                  <span className="text-white">
                    {item.applicationName} <span className="text-gray-400">({item.publisher})</span>
                  </span>
                </div>
              );
            })
          )}

          {/* Buttons */}
          <div className="mt-3 flex justify-start gap-3 ml-5 mb-2">
            <button
              className="px-4 py-2 border border-gray-400 rounded-[30px] hover:bg-gray-700"
              onClick={() => {
                setIsExpanded(false);
                setApply(false);
                setPatchFormData((prev) => ({
                  ...prev,
                  RemediationPlanActionList: prev.RemediationPlanActionList.filter((a) => a.ActionType !== 'SoftwareInstall'),
                }));
              }}
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 bg-red-600 rounded-[30px] hover:bg-red-700"
              onClick={() => {
                setApply(true);
                setIsExpanded(false);
              }}
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default InstallDropdown;
